<template>
  <client-only>
    <el-dialog
      :model-value="isCallInfoDialog"
      class="call-info-dialog"
      width="calc(100% - 50px)"
      :destroy-on-close="true"
      :show-close="false"
      append-to-body
      @close="emits('close')"
    >
      <div class="call-banner-carousel">
        <Flicking
          :plugins="plugins"
          :options="{
            align: 'center',
            circular: true,
            moveType: 'strict',
            preventDefaultOnDrag: true
          }"
          @will-change="({ index }) => (currentIndex = index)"
        >
          <div
            v-for="(item, index) in imageList"
            :key="item.id"
            :data-position="index + 1"
            :data-event-id="item.id"
            class="banners-container"
          >
            <nuxt-img :src="item.imageUrl" />
          </div>
          <template #viewport>
            <div class="flicking-pagination" />
          </template>
        </Flicking>
      </div>
      <section
        v-if="!isMobile"
        class="qr-code-section"
      >
        <!-- <nuxt-img :src="/call/appdownload-qrcode.png" /> -->
        <nuxt-img
          :src="callImg"
          width="220"
          height="220"
        />
        <div class="qr-code-text">
          <nuxt-img
            src="/call/info-qrcode.svg"
            width="16"
            height="16"
          />
          <p>QR코드 스캔하여 간편하게 설치하세요.</p>
        </div>
      </section>
      <div class="qr-code-button-wrapper">
        <UsdgCtaButton
          v-if="isMobile"
          id="gtm_call_popup_appdownload_btn"
          size="large"
          custom-class="tw:w-full"
          @click="goToStore()"
        >
          앱 다운로드 받기
        </UsdgCtaButton>
        <UsdgCtaButton
          id="gtm_call_popup_close_btn"
          class="desktop-close-button"
          size="large"
          type="fill"
          color="white"
          custom-class="tw:w-full"
          @click="emits('close')"
        >
          닫기
        </UsdgCtaButton>
      </div>
    </el-dialog>
  </client-only>
</template>

<script setup lang="ts">
import Flicking from '@egjs/vue3-flicking'
import { AutoPlay, Pagination } from '@egjs/flicking-plugins'
import '@egjs/vue3-flicking/dist/flicking.css'
import '@egjs/flicking-plugins/dist/pagination.css'

withDefaults(
  defineProps<{
    isCallInfoDialog?: boolean
  }>(),
  {
    isCallInfoDialog: true
  }
)

const emits = defineEmits(['close'])

const callImg = computed(() => {
  return '/call/img-appdownload-qrcode.png'
})

const userAgent = computed(() => {
  return import.meta.server ? useRequestHeaders()['user-agent'] || '' : navigator.userAgent || ''
})

const isMobile = /mobile|android|iphone|ipad|ipod/i.test(userAgent.value.toLowerCase())

const imageList = [
  {
    imageUrl: '/call/img-banner-call01-v2.png',
    id: '1'
  },
  {
    imageUrl: '/call/img-banner-call02.png',
    id: '2'
  }
]

const currentIndex = ref<number>(0)

const plugins = [
  new AutoPlay({
    animationDuration: 1000,
    stopOnHover: true
  }),
  new Pagination({
    type: 'bullet',
    bulletCount: 5
  })
]

const goToStore = () => {
  navigateTo('/redirect-to-store')
}
</script>

<style lang="scss">
.call-info-dialog {
  color: $gray-700;
  border-radius: 12px !important;
  max-width: 328px;
  position: fixed !important;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  @include desktop {
    top: 35%;
    transform: translate(-50%, -50%);
    bottom: auto;
  }
}
</style>

<style scoped lang="scss">
.call-banner-carousel {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  .banners-container {
    width: 100%;
    margin-right: 10px;
    padding-bottom: 16px;
    img {
      width: 100%;
      height: 94px;
      -webkit-user-drag: none;
    }
  }

  :deep(.flicking-pagination) {
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 0;
    z-index: 90;
    padding-top: 8px;
    .flicking-pagination-bullet-active {
      background-color: $gray-600 !important;
    }
  }
}
.qr-code-section {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 16px;
  color: $gray-700;
  margin-top: 16px;
  padding: 0 20px;
  .qr-code-text {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    border-radius: 8px;
    background: var(--Colors-blue-100, #eff6ff);
    margin-top: 12px;
    padding: 12px 16px;
    p {
      @include footnote1-medium;
      color: $brand-point;
    }
  }
}
.qr-code-button-wrapper {
  margin: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
